var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicNoCalculation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 125,
    viewBox: "0 0 129 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6013 36.3286C62.3775 35.4554 62.4817 32.6587 62.7462 31.4685C63.0413 30.1404 62.4456 26.9139 63.243 25.9172C64.5081 24.3358 63.5454 19.9106 63.5454 17.8601C63.5454 16.2401 63.5454 14.62 63.5454 13",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.874 42.9397C87.7201 42.8339 89.6147 39.4214 90.3733 38.6628C91.9805 37.0556 93.3559 35.1186 94.9526 33.5218C96.2871 32.1874 97.6524 30.8971 98.9272 29.5473C99.9733 28.4397 101.722 27.2407 102.426 25.832",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7607 65.1016H116.424",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0964 86.0977C86.9199 86.2006 88.3219 88.3558 88.8397 89.0353C89.9978 90.5553 92.0164 92.5231 93.6998 93.4851C95.1518 94.3147 96.1489 95.7244 97.3719 96.8116C98.9199 98.1875 101.392 99.1919 102.426 101.261",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2124 89.207C61.2124 97.0044 61.6012 105.012 61.6012 112.924",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4978 95.8181C23.6609 94.5134 26.8251 91.7937 27.9475 91.1523C29.7533 90.1205 31.385 88.366 33.0237 87.0914C34.5229 85.9254 35.9257 84.695 37.3222 83.3761C38.1856 82.5607 40.1316 81.2134 40.6055 80.2656",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57.7129C20.064 58.4978 27.2025 58.4905 34.3846 58.4905",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2739 26.2207C33.6104 27.4577 35.677 30.5329 37.4949 32.4417C38.7901 33.8017 40.8299 34.7138 41.6854 36.3298C42.7834 38.4038 44.947 40.6876 46.4375 42.5508",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicNoCalculation);
export default __webpack_public_path__ + "static/media/graphic-no-calculation.dff26d276565e6b7817a408633a7d661.svg";
export { ForwardRef as ReactComponent };